/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Stazioni } from "./Stazioni";
import { Pa } from "./Pa";
import * as t from "io-ts";

// required attributes
const PaStazionePaR = t.interface({});

// optional attributes
const PaStazionePaO = t.partial({
  aca: t.boolean,

  auxDigit: t.Integer,

  broadcast: t.boolean,

  fkPa: t.Integer,

  objId: t.Integer,

  pa: Pa,

  pagamentoSpontaneo: t.boolean,

  progressivo: t.Integer,

  quartoModello: t.boolean,

  segregazione: t.Integer,

  standin: t.boolean
});
// NOTE: fix-circular-generated-models: patched to break a circular
// import cycle detected among: Stazioni, PaStazionePa.
// This block is regenerated automatically by
// scripts/fix-circular-generated-models.js after every `gen-api-models` run
// - do not hand-edit `generated/` files, they are wiped on each generation.
export type PaStazionePa = t.TypeOf<typeof PaStazionePaR> &
  t.TypeOf<typeof PaStazionePaO> & {
  readonly "fkStazione"?: Stazioni;
  };

export const PaStazionePa: t.Type<PaStazionePa> = t.recursion("PaStazionePa", () =>
  t.intersection(
    [PaStazionePaR, t.partial({ ...PaStazionePaO.props, "fkStazione": Stazioni })],
    "PaStazionePa"
  ) as unknown as t.Type<PaStazionePa>
);
